/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-unused-vars */
/* eslint-disable-next-line no-shadow */
export enum SessionState {
    ERROR,
    NONE,
    SUCCESS,
    UNREACHABLE,
}
